module.exports = __webpack_public_path__ + "img/water7.a4d9381c.jpg";